// src/utils/authStore.js

const AUTH_KEY = "orbismed_patient_auth";

/**
 * Store complete auth session
 * @param {Object} session - Contains access_token, token_type, and patient data
 */
export function setAuthSession(session) {
  localStorage.setItem(AUTH_KEY, JSON.stringify(session));
}

/**
 * Get complete auth session
 * @returns {Object|null} - Auth session or null
 */
export function getAuthSession() {
  try {
    return JSON.parse(localStorage.getItem(AUTH_KEY) || "null");
  } catch {
    return null;
  }
}

/**
 * Clear auth session (logout)
 */
export function clearAuthSession() {
  localStorage.removeItem(AUTH_KEY);
  // Also clear any legacy keys if they exist
  localStorage.removeItem("auth_token");
  localStorage.removeItem("token_type");
  localStorage.removeItem("patient_data");
  localStorage.removeItem("user_email");
}

/**
 * Get access token
 * @returns {string|null}
 */
export function getAccessToken() {
  const session = getAuthSession();
  return session?.access_token || null;
}

/**
 * Get current patient data
 * @returns {Object|null}
 */
export function getPatient() {
  const session = getAuthSession();
  return session?.patient || null;
}

/**
 * Check if user is authenticated
 * @returns {boolean}
 */
export function isAuthenticated() {
  return Boolean(getAccessToken());
}

/**
 * Get auth headers for API requests
 * @returns {Object}
 */
export function getAuthHeaders() {
  const token = getAccessToken();
  return token ? {
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
  } : {
    "Content-Type": "application/json",
  };
}

/**
 * Logout user and clear all auth data
 */
export function logout() {
  clearAuthSession();
}

/**
 * Get user role (for multi-role systems)
 * @returns {string}
 */
export function getRole() {
  return "patient"; // For patient portal, role is always "patient"
}